export default __webpack_public_path__ + "static/media/contact-img.d2cb690e.svg";